<template>
  <loan-list
    filter="Personal"
    :title="$t('menu.personalLoan')"
  />
</template>

<script>
import LoanList from './List'

export default {
  name: 'PersonalLoanList',
  metaInfo () {
    return {
      title: this.$t('menu.personalLoan'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { LoanList }
}
</script>

<style scoped>

</style>
